import { Component, OnInit, Input, NgZone, ElementRef, Renderer2, Inject, HostBinding } from '@angular/core';
import { environment } from '../../environment';
import { sleep } from 'common';
import { DOCUMENT } from '@angular/common';

interface CountQueueItem {
  id : string;
  callback : (count : number) => void;
}

let COUNT_QUEUE : CountQueueItem[] = [];
let COUNT_UPDATE_TIMEOUT;

@Component({
  selector: 'tyt-comments-count',
  templateUrl: './comments-count.component.html',
  styleUrls: ['./comments-count.component.scss']
})
export class CommentsCountComponent implements OnInit {

  constructor(
    private ngZone : NgZone,
    private elementRef : ElementRef,
    private renderer : Renderer2
  ) { }

  _identifier : string = null;

  @Input() 
  get identifier() : string {
    return this._identifier;
  }

  set identifier(value : string) {
    if (this._identifier == value)
      return;

    this._identifier = value;
    this.update();
  }
  
  ngOnInit() {
  }

  count : number;

  updateCounts() {
    if (typeof window === 'undefined')
      return;

    clearTimeout(COUNT_UPDATE_TIMEOUT);
    COUNT_UPDATE_TIMEOUT = setTimeout(async () => {
      if (COUNT_QUEUE.length == 0)
        return;
      
      let items = COUNT_QUEUE.splice(0, 30);
      let response = await fetch(`https://open-api.spot.im/v1/messages-count?spot_id=${environment.spotId}&posts_ids=${items.map(x => x.id).join(',')}`);
      if (!response.ok) {
        console.error(`Failed to fetch comment count for topic ${this._identifier}: ${response.status}`);
        return;
      }
  
      let result = await response.json();

      for (let item of items) {
        item.callback(result.messages_count[item.id] || 0);
      }

      if (COUNT_QUEUE.length > 0)
        this.updateCounts();
    }, 1000);
  }

  @HostBinding('class.visible')
  get hasCount() {
    return this.count !== void 0;
  }

  async update() {
    if (!this._identifier)
      return;

    // Never save to COUNT_QUEUE when in SSR, because we are never 
    // emptying the queue. Memory leak found mid August 2021

    if (typeof window === 'undefined')
      return;
    
    COUNT_QUEUE.push({
      id: this._identifier,
      callback: count => this.count = count
    });

    this.updateCounts();
  }
}
